import mutations from './moduleRoundUpsMutations.js'
import actions from './moduleRoundUpsActions.js'
import getters from './moduleRoundUpsGetters.js'

const getDefaultState = () => {
  return {
    donationsState: null,//null, loading, ready
    donations: [],
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions,
  getters
}

